import { Route, Routes } from 'react-router-dom';
import EditWrapper from './EditWrapper';
import EditContent from './EditContent';
import { MediaRoutes } from '../../components/edit/media/MediaRoutes';

const EditRoutes = () => {
  return (
    <Routes>
      <Route element={<EditWrapper />}>
        <Route index element={<EditContent />} />
        <Route path="media/*" element={<MediaRoutes />} />
      </Route>
    </Routes>
  );
};

export default EditRoutes;
